export default {"src":"/_next/static/media/renewables-logo.74198cb5.svg","height":162,"width":500,"blurWidth":0,"blurHeight":0};